module.exports = __webpack_public_path__ + "static/shiv@3x-3e93471174d0f304c50f3eaf300ec3b4.png";